<template>
<div class="loader-box"  :class="{'inline':type=='inline'}" v-if="show">
    <div class="loader">
       <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
</div>
</template>

<script>
export default {
    name: "Loader",
    props:['show','type'],
    methods:{
    
    }
};
</script>

<style scoped>
.loader-box {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(255,255,255,.8);
    top: 0px;
    left: 0px;
    z-index: 2500;
    display: flex;
    justify-content:center;
    align-items: center;
}
.loader-box.inline{
    /* height: 600px; */
    position: relative;
    background-color: transparent;
}
.loader{
  margin: auto;
    /* background-color: #fff; */
    width: 180px;
    height: 180px;
    /* border-radius: 50%; */
    display: flex;
    justify-content:center;
    align-items: center; 
}
.icon{
   width: 100%;
    height: 100%;
    /* background: url(~@/assets/img/loader.gif); */
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
